import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "../../../utills/api";
import {
  Card,
  CardBody,
  Container,
  Badge,
} from "reactstrap";
import { toast } from "react-toastify";

const ChefOrderPage = () => {
  const { orderId } = useParams();

  const [order, setOrder] = useState(null);

  const fetchOrder = async () => {
    try {
      const res = await axios.get(
        `/food/chef-order/${orderId}`
      );

      setOrder(res.data.order);
    } catch (err) {
      console.error(err);
      toast.error("Order not found");
    }
  };

  useEffect(() => {
    fetchOrder();
  }, [orderId]);

  const updateStatus = async (newStatus) => {
    try {
      await axios.patch(
        `/food/chef-order/${orderId}/status`,
        {
          status: newStatus,
        }
      );

      setOrder((prev) => ({
        ...prev,
        chefStatus: newStatus,
        status: newStatus,
      }));

      toast.success(
        `Status updated to ${newStatus}`
      );
    } catch (err) {
      console.error(err);
      toast.error(
        "Failed to update status"
      );
    }
  };

  if (!order) {
    return (
      <div className="p-5 text-center">
        Loading...
      </div>
    );
  }

  const orderNumber =
    order.orderId ||
    order.kotNumber ||
    "-";

  const guestName =
    order.guestName ||
    "Room Service";

  const amount =
    order.finalAmount ||
    order.grandTotal ||
    order.totalAmount ||
    0;

  const currentStatus =
    order.chefStatus ||
    order.status ||
    "Waiting";

  const getStatusColor = () => {
    switch (currentStatus) {
      case "Delivered":
        return "success";

      case "Preparing":
        return "warning";

      case "Approved":
        return "info";

      case "Cancelled":
        return "danger";

      default:
        return "secondary";
    }
  };

  return (
    <Container
      style={{
        maxWidth: "750px",
        marginTop: "30px",
      }}
    >
      <Card
        style={{
          borderRadius: "12px",
          border: "1px solid #e9ecef",
        }}
      >
        <CardBody>

          <h3 className="mb-4">
            🍽 Order Details
          </h3>

          <div className="mb-2">
            <strong>Order ID:</strong>{" "}
            {orderNumber}
          </div>

          <div className="mb-2">
            <strong>Guest:</strong>{" "}
            {guestName}
          </div>

          <div className="mb-2">
            <strong>Room No:</strong>{" "}
            {order.roomNumber || "-"}
          </div>

          <div className="mb-2">
            <strong>Order Type:</strong>{" "}
            {order.orderType ||
              "ROOM_SERVICE"}
          </div>

          <hr />

          <h5 className="mb-3">
            Ordered Items
          </h5>

          {(order.items || []).map(
            (item, index) => {
              const englishName =
                typeof item.name ===
                "object"
                  ? item.name?.en
                  : item.name;

              const hindiName =
                typeof item.name ===
                "object"
                  ? item.name?.hi
                  : "";

              return (
                <div
                  key={index}
                  className="d-flex justify-content-between align-items-start mb-3"
                >
                  <div>
                    <div
                      style={{
                        fontWeight: 600,
                      }}
                    >
                      {englishName}
                    </div>

                    {hindiName && (
                      <div
                        style={{
                          fontSize:
                            "14px",
                          color:
                            "#6c757d",
                        }}
                      >
                        {hindiName}
                      </div>
                    )}
                  </div>

                  <div>
                    Qty:{" "}
                    {item.quantity ||
                      1}
                  </div>

                  <div>
                    ₹
                    {item.total ||
                      item.price ||
                      0}
                  </div>
                </div>
              );
            }
          )}

          <hr />

          <div className="mb-3">
            <strong>
              Total Amount:
            </strong>{" "}
            ₹{amount}
          </div>

          <div className="mb-4">
            <strong>
              Current Status:
            </strong>{" "}
            <Badge
              color={
                getStatusColor()
              }
            >
              {currentStatus}
            </Badge>
          </div>

          <div className="d-flex gap-2 flex-wrap">

            <button
              className="btn btn-info"
              onClick={() =>
                updateStatus(
                  "Approved"
                )
              }
              disabled={
                currentStatus ===
                "Approved"
              }
            >
              Approve
            </button>

            <button
              className="btn btn-warning text-white"
              onClick={() =>
                updateStatus(
                  "Preparing"
                )
              }
              disabled={
                currentStatus ===
                "Preparing"
              }
            >
              Start Preparing
            </button>

            <button
              className="btn btn-success"
              onClick={() =>
                updateStatus(
                  "Delivered"
                )
              }
              disabled={
                currentStatus ===
                "Delivered"
              }
            >
              Delivered
            </button>

          </div>

        </CardBody>
      </Card>
    </Container>
  );
};

export default ChefOrderPage;